import { createGlobalState } from "react-hooks-global-state"

const { useGlobalState, setGlobalState } = createGlobalState({
  printCharacteristic: null,
  printername: null,
})

export { useGlobalState, setGlobalState }
